module.exports = __webpack_public_path__ + "img/logoMargaritaville.f31531e8.png";